import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { CommonModule } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgxPaginationModule } from "ngx-pagination";
import { RouterModule, Routes } from "@angular/router";
import { A11yModule } from '@angular/cdk/a11y';


import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { KebabComponent } from "./components/kebab/kebab.component";
import { ModalComponent } from "./components/modal/modal.component";
import { PreviewModalComponent } from "./components/preview.modal/preview.modal.component";
import { CommonModalComponent } from "./components/common.modal/common.modal.component";
import { MyAssessmentComponent } from "./components/my-assessment/my-assessment.component";
import { GlobalHeaderComponent } from "./components/global-header/global-header.component";
import { SearchComponent } from "./components/search/search.component";
import { SourcePickerComponent } from "./components/source-picker/source-picker.component";
import { SourceBankComponent } from "./components/source-bank/source-bank.component";
import { SortDirective } from "./directives/sorting.directive";
import { ClickOutsideDirective } from "./directives/clickOutside.directive";
import { AssessmentNameValidatorDirective } from "./directives/nameValidator.directive";
import { TextareaResizeDirective } from "./directives/textareaResize.directive";

import { AssessmentListService } from "./services/assessment-list.service";
import { ItemsListService } from "./services/items-list.service";
import { ShareDataService } from "./services/shared.service";
import { SourceInfoService } from "./services/source-info.service";
import { SaveAssessmentService } from "./services/save-assessment.service";
import { SelectedBankQuestionsService } from "./services/selected-bank-questions.service";
import { PreferenceComponent } from "./components/preference/preference.component";
import { ColledtionId } from "./services/collection-id.service";
import { DeleteAssessmentService } from "./services/delete-assessment.service";
import { TruncatePipe } from "./pipes/truncate-filter.pipe";
import { LinebreakPipe } from "./pipes/line-break.pipe";
import { PaginatePipe } from "./pipes/pagination.pipe";
import { ViewAssessmentInfoService } from "./services/view-assessment-info.service";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { QuestionFilterPipe } from "./pipes/question-filter.pipe";
import { OrderByPipe } from "./pipes/order-by.pipe";
import { QuestionTypeDropdownComponent } from "./components/question-type-dropdown/question-type-dropdown.component";
import { EditorQuestionsService } from "./services/editor-questions.service";
import { SafeUrlPipe } from "./pipes/safeUrl.pipe";
import { SanitizeHtmlPipe } from "./pipes/sanitizeHtml.pipe";
import { SourceQuestionComponent } from "./components/source-question/source-question.component";
import { ButtonComponent } from './components/button/button.component';
import { AlertComponent } from './components/alert/alert.component';
import { TranslateDirective } from './services/translate/translate.directive';
import { TranslateModule } from "./services/translate";
import { CheckboxComponent, CheckboxModule } from "./components/checkbox";
import { InputComponent } from './components/input/input.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { TabComponent } from './components/tabs/tab/tab.component';
import { SharedModalComponent } from './components/shared-modal/shared-modal.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { OverlayComponent } from './components/overlay/overlay.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { PagerComponent } from './components/pager/pager.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { TooltipDirective } from './components/tooltip/tooltip.directive';
import { AppButtonComponent } from "./components/button";
import { RequiredIndicatorModule } from './components/required-indicator/required-indicator.module';

@NgModule({ 
    declarations: [
        HeaderComponent,
        FooterComponent,
        ModalComponent,
        CommonModalComponent,
        PreviewModalComponent,
        MyAssessmentComponent,
        GlobalHeaderComponent,
        SourcePickerComponent,
        SourceBankComponent,
        SourceQuestionComponent,
        PreferenceComponent,
        SortDirective,
        ClickOutsideDirective,
        AssessmentNameValidatorDirective,
        TextareaResizeDirective,
        KebabComponent,
        SearchComponent,
        TruncatePipe,
        LinebreakPipe,
        PaginatePipe,
        QuestionFilterPipe,
        OrderByPipe,
        QuestionTypeDropdownComponent,
        SafeUrlPipe,
        SanitizeHtmlPipe,
        ButtonComponent,
        AlertComponent,
        InputComponent,
        TabsComponent,
        TabComponent,
        SharedModalComponent,
        DropdownComponent,
        OverlayComponent,
        SpinnerComponent,
        PagerComponent,
        TooltipComponent,
        TooltipDirective,
        AppButtonComponent,
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        ModalComponent,
        CommonModalComponent,
        PreviewModalComponent,
        SourcePickerComponent,
        SourceBankComponent,
        SourceQuestionComponent,
        MyAssessmentComponent,
        GlobalHeaderComponent,
        PreferenceComponent,
        SortDirective,
        ClickOutsideDirective,
        AssessmentNameValidatorDirective,
        TextareaResizeDirective,
        KebabComponent,
        SearchComponent,
        TruncatePipe,
        LinebreakPipe,
        PaginatePipe,
        OrderByPipe,
        QuestionTypeDropdownComponent,
        ButtonComponent,
        AlertComponent,
        CheckboxComponent,
        InputComponent,
        TabsComponent,
        TabComponent,
        SharedModalComponent,
        DropdownComponent,
        SpinnerComponent,
        TooltipComponent,
        TooltipDirective,
        PagerComponent,
        DragDropModule,
        AppButtonComponent,
    ],
    imports: [
        A11yModule,
        FormsModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        CommonModule,
        TranslateModule,
        CheckboxModule,
        DragDropModule,
        RequiredIndicatorModule,
    ],
    providers: [
        AssessmentListService,
        ShareDataService,
        SourceInfoService,
        SaveAssessmentService,
        EditorQuestionsService,
        SelectedBankQuestionsService,
        ColledtionId,
        DeleteAssessmentService,
        ViewAssessmentInfoService,
        ItemsListService,
        QuestionFilterPipe,
        PaginatePipe,
        OrderByPipe,
        provideHttpClient(withInterceptorsFromDi()),
    ]})
export class SharedModule {}
